const state = {
  notification: {
    visible: false,
    text: null,
    timeout: 6000,
    multiline: false,
    status: '',
    icon: '',
    color: ''
  }
}

const mutations = {
  showNotification: (state, payload) => {
    state.notification.text = payload.text;
    state.notification.status = payload.status;
    state.notification.icon = payload.status === 'success' ? 'check' : 'warning';
    state.notification.color = payload.status;
    state.notification.multiline = (payload.text.length > 50) ? true : false;

    if (payload.multiline) {
      state.notification.multiline = payload.multiline;
    }

    if (payload.timeout) {
      state.notification.timeout = payload.timeout
    }

    state.notification.visible = true;
  },

  closeNotification: state => {
    state.notification.visible = false;
    state.notification.multiline = false;
    state.notification.timeout = 6000;
    state.notification.text = null;
  }
}

export default {
  state,
  mutations
}